import { FeaturedIcon } from '@backrs_ui/common-ui';

import { ReactComponent as BackgroundGrid } from '@backrs_ui/common-ui/src/assets/images/background-grid.svg';
import { ReactComponent as FactHexagon } from '@backrs_ui/common-ui/src/assets/images/facts-hexagon.svg';

import { Box, Typography, SxProps, Theme, useMediaQuery } from '@mui/material';

type QuestionTextProps = Readonly<{
  hasFacts: boolean;
  handleFactClick?: () => void;
  title: string;
  question_body: string;
}>;

export function QuestionText({
  hasFacts,
  handleFactClick,
  title,
  question_body,
}: QuestionTextProps) {
  const isMobile = useMediaQuery('(max-width: 600px)');

  return (
    <Box sx={relativeSx}>
      <Box sx={backgroundGridSx}>
        <BackgroundGrid />
      </Box>
      <Box sx={headerSx}>
        <Box sx={iconContainerSx}>
          <FeaturedIcon
            iconName="Hash01"
            size="lg"
            color="Colors/Foreground/fg-secondary"
            borderColor="Beige/950"
          />
          {isMobile && hasFacts && handleFactClick && (
            <Box onClick={handleFactClick} sx={{ cursor: 'pointer' }}>
              <FactHexagon width="90px" height="50px" />
            </Box>
          )}
        </Box>
        <Box sx={titleDescriptionContainerSx}>
          <Typography
            color={(theme: Theme) => theme.backrs.colors['Beige/950']}
            variant="text-lg-semibold"
          >
            {title}
          </Typography>
          <Typography
            variant="text-md-regular"
            color={(theme: Theme) => theme.backrs.colors['Colors/Base/Black']}
          >
            {question_body}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

const relativeSx: SxProps<Theme> = {
  position: 'relative',
};

const backgroundGridSx: SxProps<Theme> = {
  position: 'absolute',
  transform: 'translate(0%, 2%)',
  zIndex: 0,
};

const headerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xl'],
  zIndex: 999,
  position: 'relative',
  px: backrs.spacing['spacing-3xl'],
  pt: backrs.spacing['spacing-3xl'],
});

const titleDescriptionContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xs'],
});

const iconContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
};
